import SchemaSelector from '../../../widgets/SchemaSelector';

const SchemaSelectorModal = ({ isOpen, onClose, schemas, currentSchemaId, onApply }) => {
    if (!isOpen) return null;
    
    const handleSchemaApply = (newSchema) => {
        if (onApply) {
            onApply(newSchema);
        }
        onClose();
    };
    
    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000
            }}
            onClick={onClose}
        >
            <div 
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    maxWidth: '600px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1em',
                    borderBottom: '1px solid #dee2e6'
                }}>
                    <h3 style={{ margin: 0 }}>Schema Version</h3>
                    <button 
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5em',
                            cursor: 'pointer',
                            color: '#666',
                            padding: '0',
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        ×
                    </button>
                </div>
                <div style={{ padding: '1em' }}>
                    <SchemaSelector
                        schemas={schemas}
                        onSelect={handleSchemaApply}
                        defaultValue={currentSchemaId}
                    />
                </div>
            </div>
        </div>
    );
};

export default SchemaSelectorModal;
